import cn from "classnames"
import { lazy, Suspense } from "react"

import { Card, Col, Flex, Row } from "@/atoms"
import { useWorkflowById } from "@/organisms/Drawers/applications/ai-discovery/useAiDiscovery"
import {
  ModelsCard,
  RelatedResourcesCard
} from "@/organisms/Drawers/components/AgentAiDiscoveryDrawer/components/OverviewCards"
import { TABS } from "@/organisms/Drawers/components/AgentAiDiscoveryDrawer/const"
import { useActiveTab } from "@/organisms/Drawers/components/AgentAiDiscoveryDrawer/hooks/useActiveTab"
import { WorkflowIcon } from "@/pages/AiDiscovery/components/molecules/WorkflowTypeCell/WorkflowTypeIcons"

import styles from "@/organisms/Drawers/components/AgentAiDiscoveryDrawer/components/OverviewTabAgentAiDiscoveryDrawer/OverviewTabAgentAiDiscoveryDrawer.module.scss"

import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

const DataFlowGraph = lazy(() =>
  import("@/organisms/Drawers/components/AgentAiDiscoveryDrawer/components/DataFlowGraph").catch(
    () => ({
      default: () => <div>Failed to load Data Flow Graph</div>
    })
  )
)

export const OverviewTabWorkflowAiDiscoveryDrawer = (
  props: TabComponentProps
) => {
  const { data, isLoading } = useWorkflowById(props)
  const { name, description, models, project, dataSources, dataSinks } =
    data || {}
  const cardClassName = cn("card-agent-ai-discovery-drawer", styles.card)
  const columnCard = cn(cardClassName, !isLoading && styles.cardColumn)
  const itemCard = cn(columnCard, !isLoading && styles.cardItem)
  const { active } = useActiveTab(TABS.overview, data, props)

  return (
    <Row gutter={[16, 16]} className="container-agent-ai-discovery-drawer">
      <Col span={24}>
        <Suspense
          fallback={
            <Card loading title="Data Flow" className={cardClassName} />
          }
        >
          <Card
            loading={isLoading}
            title="Data Flow"
            className={cn(cardClassName, !isLoading && styles.cardGraph)}
          >
            <div className={styles.graph}>
              {active && (
                <DataFlowGraph
                  key={data?.id}
                  // The center is the workflow itself: the models it runs belong to its agents
                  data={{
                    name,
                    dataSources,
                    dataSinks,
                    rootIcon: WorkflowIcon
                  }}
                />
              )}
            </div>
          </Card>
        </Suspense>
      </Col>
      <Col span={14}>
        <Card
          loading={isLoading}
          title="Description"
          className={cn(columnCard, !isLoading && styles.cardDescription)}
        >
          <Flex vertical gap={8}>
            <span className="sm-text-ks">{description}</span>
          </Flex>
        </Card>
      </Col>
      <Col span={10}>
        <Flex vertical gap={16}>
          <ModelsCard
            loading={isLoading}
            className={itemCard}
            models={models}
          />
          <RelatedResourcesCard
            loading={isLoading}
            className={itemCard}
            resources={project?.resources}
          />
        </Flex>
      </Col>
    </Row>
  )
}
